/* Anmeldelsesraekken paa Copenhagen Bamboo. Tre smaa rettelser oven paa
   Judge.mes widget, som vi ikke kan styre andre steder fra: deres API afviser
   at skrive indstillinger (maalt 1/9-2026: 404 paa fem endpoints), saa alt
   nedenfor skal ellers klikkes i Judge.mes egen app.

   1) Gennemsnittet: Judge.me skriver "4.82 out of 5". Her kortes det til tallet
      alene, med komma paa de sprog der bruger komma.
   2) Sortering: bedste anmeldelser foerst i stedet for nyeste, som paa
      bambustoej. Saettes helst i Judge.mes egne settings inden widgeten bygger,
      saa siden ikke hopper; ellers rettes dropdownen bagefter.
   3) De to sidste engelske rester, "Sort by" og "Write a review". Begge er
      visuelt skjulte (skaermlaeser-etiket og en skjult knap), saa det her er for
      skaermlaesernes skyld - en svensk side skal ikke laese engelsk op.

   Sker der intet, staar Judge.mes egen tekst. Intet gaar tabt. */
(function () {
  var SORTERING = 'highest-rating';

  /* Sker foer widgeten bygger, hvis vores fil naar frem foerst. */
  try {
    if (window.jdgmSettings) {
      window.jdgmSettings.default_sort_method = SORTERING;
      window.jdgmSettings.all_reviews_widget_v2025_default_sort_method = SORTERING;
    }
  } catch (e) {}

  var TEKST = {
    da: { sorter: 'Sortér efter', skriv: 'Skriv en anmeldelse' },
    sv: { sorter: 'Sortera efter', skriv: 'Skriv en recension' },
    de: { sorter: 'Sortieren nach', skriv: 'Bewertung schreiben' },
    en: { sorter: 'Sort by', skriv: 'Write a review' }
  };

  function sprog() {
    var l = (document.documentElement.lang || 'da').toLowerCase().slice(0, 2);
    return TEKST[l] ? l : 'en';
  }

  var maal = document.querySelector('.cb-anm-widget');
  if (!maal) return;
  var ord = TEKST[sprog()];
  var sorteret = false;
  var runder = 0;

  var t = setInterval(function () {
    runder++;
    if (runder > 40) clearInterval(t);

    /* 1) gennemsnittet */
    var a = maal.querySelector('.jdgm-rev-widg__summary-average .jdgm-link, .jdgm-rev-widg__summary-average');
    if (a) {
      var m = (a.textContent || '').match(/[\d]+([.,][\d]+)?/);
      if (m) {
        var tal = m[0];
        if (sprog() !== 'en') tal = tal.replace('.', ',');
        if (a.textContent.trim() !== tal) a.textContent = tal;
      }
    }

    /* 2) bedste foerst.
       Det er ikke nok at saette jdgmSettings og dropdownens vaerdi: widgeten har
       allerede hentet listen paa det tidspunkt, saa dropdownen viser
       "Hoejeste vurdering" mens raekkefoelgen stadig er nyeste. MAALT 1/9-2026:
       5,3,5,5,5 i stedet for lutter femmere. Derfor sendes change-signalet
       altid EEN gang, saa Judge.me henter listen om. */
    var sel = maal.querySelector('.jdgm-sort-dropdown');
    if (sel && !sorteret && maal.querySelector('.jdgm-rev')) {
      sorteret = true;

      /* Judge.me tror et menneske sorterede, og ruller derfor siden ned til
         anmeldelserne. MAALT 10/9-2026: siden hoppede til 1967 px af sig selv,
         hver gang en produktside blev aabnet. Deres egen kontakt
         jdgmSettings.scrollTo maa returnere false for at afvise rullet; den
         laeses ved hvert kald, saa den lukkes kun i de faa sekunder vores eget
         signal er undervejs. Bagefter er den tilbage, saa kundens egne klik i
         sorteringen ruller som foer. */
      var scrollKontakt = window.jdgmSettings && window.jdgmSettings.scrollTo;
      try {
        window.jdgmSettings.scrollTo = function () { return false; };
        setTimeout(function () {
          window.jdgmSettings.scrollTo = scrollKontakt || function () {};
        }, 4000);
      } catch (e) {}

      sel.value = SORTERING;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* 3) de to engelske rester */
    var label = maal.querySelector('.jdgm-sort-dropdown-label');
    if (label && label.textContent.trim() !== ord.sorter) label.textContent = ord.sorter;
    var skriv = maal.querySelector('.jdgm-write-rev-link');
    if (skriv && skriv.textContent.trim() !== ord.skriv) skriv.textContent = ord.skriv;
  }, 500);
})();
